<template>
  <div class="content">
    <v-dialog v-model="showForm" persistent max-width="560px" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card class="pv-dialogo">
        <v-card-title class="pv-dialogo-titulo">
          <span class="text-h6">
            {{ edit ? "Editar punto de venta" : "Nuevo punto de venta" }}
          </span>
          <v-spacer></v-spacer>
          <v-btn icon aria-label="Cerrar" @click="edit ? cerrar_edit_punto() : cerrar_create()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-2">
          <v-form ref="form_create" v-model="valid" lazy-validation>
            <v-text-field v-model="currentItem.nombre" :counter="45" :rules="namecuenta" label="Nombre"
              hint="Letras, números, - y _, sin espacios. Ej: Sucursal_Centro-1" persistent-hint class="mb-4"
              required></v-text-field>
            <v-row dense>
              <v-col cols="8">
                <v-text-field v-model="currentItem.calle" :counter="145" :rules="edit ? [] : calle" label="Calle"
                  required></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="currentItem.numero_calle" :counter="15" :rules="edit ? [] : nroCalle"
                  label="Número" inputmode="numeric" required></v-text-field>
              </v-col>
            </v-row>
            <v-text-field v-if="!edit" v-model="currentItem.codigo_postal" :counter="25" :rules="codigoPostal"
              label="Código postal" inputmode="numeric" required></v-text-field>

            <v-switch v-model="currentItem.en_pronto_pagos" inset color="primary" class="mt-2"
              label="Cobrar con Pronto Pagos" persistent-hint
              :hint="currentItem.en_pronto_pagos
                ? 'El punto de venta y sus cajas se crean en Pronto Pagos.'
                : 'El punto de venta y sus cajas se crean en APILINK.'"></v-switch>
            <v-switch v-if="edit" v-model="currentItem.activo" inset color="primary"
              :label="currentItem.activo ? 'Activo' : 'Inactivo'"></v-switch>
          </v-form>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn text @click="edit ? cerrar_edit_punto() : cerrar_create()">
            Cancelar
          </v-btn>
          <v-btn color="primary" depressed :disabled="!valid" :loading="cargando"
            @click="edit ? handleUpdate() : handleStore()">
            {{ edit ? "Guardar cambios" : "Crear punto de venta" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <modalCaja :showCaja="showCaja" :sucursal="sucursal" :usuarios="usuarios || []"
      @closeModalCaja="cerrar_caja()" />

    <LayoutPage :title="'Puntos de venta'">
      <div class="pv-barra">
        <v-btn text color="primary" class="px-2" :to="`/cliente/${cliente_id}/cuentas`">
          <v-icon left>mdi-arrow-left</v-icon>
          Cuentas
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" depressed @click="openNewPunto()">
          <v-icon left>mdi-plus</v-icon>
          Nuevo punto de venta
        </v-btn>
      </div>

      <v-alert v-if="errored" type="error" text outlined class="mb-4">
        <div class="pv-alerta">
          <span>No pudimos traer los puntos de venta. Probá de nuevo en unos minutos.</span>
          <v-btn small text color="error" @click="getDatos()">Reintentar</v-btn>
        </div>
      </v-alert>

      <v-alert v-if="busqueda && usuario" type="info" text dismissible class="mb-4">
        <div class="pv-busqueda-titulo">Resultado de la búsqueda de usuario</div>
        <dl class="pv-busqueda">
          <dt>Punto de venta</dt>
          <dd>{{ usuario.PuntoDeVenta || "—" }}</dd>
          <dt>Código de sucursal</dt>
          <dd>{{ usuario.CodigoSucursal || "—" }}</dd>
          <dt>Caja</dt>
          <dd>{{ usuario.CajaNombre || "—" }}</dd>
        </dl>
      </v-alert>

      <v-data-table :search="search" :headers="headers" :items="itemsPuntos" :loading="cargando"
        :items-per-page="rowsPerPage" hide-default-footer disable-sort loading-text="Cargando puntos de venta…"
        class="pv-tabla">
        <template v-slot:no-data>
          <div v-if="!errored" class="pv-vacio">
            <v-icon size="40" color="grey lighten-1">mdi-store-outline</v-icon>
            <p class="pv-vacio-titulo">Esta cuenta todavía no tiene puntos de venta</p>
            <p class="pv-vacio-texto">Creá uno para poder darle cajas y cobrar con QR.</p>
            <v-btn color="primary" depressed @click="openNewPunto()">
              <v-icon left>mdi-plus</v-icon>
              Nuevo punto de venta
            </v-btn>
          </div>
          <span v-else>Sin datos para mostrar.</span>
        </template>

        <template v-slot:[`item.nombre`]="{ item }">
          <div class="pv-nombre">{{ item.nombre }}</div>
          <div v-if="direccion(item)" class="pv-secundario">{{ direccion(item) }}</div>
        </template>

        <template v-slot:[`item.en_pronto_pagos`]="{ item }">
          <v-chip small label :color="item.en_pronto_pagos ? 'blue lighten-5' : 'grey lighten-4'"
            :text-color="item.en_pronto_pagos ? 'blue darken-3' : 'grey darken-3'">
            {{ item.en_pronto_pagos ? "Pronto Pagos" : "APILINK" }}
          </v-chip>
        </template>

        <template v-slot:[`item.codigo_sucursal_link`]="{ item }">
          <div class="pv-codigo">
            <span class="pv-codigo-texto">{{ item.codigo_sucursal_link }}</span>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon x-small aria-label="Copiar código de sucursal" v-bind="attrs" v-on="on"
                  @click="copiar(item.codigo_sucursal_link)">
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>Copiar código</span>
            </v-tooltip>
          </div>
        </template>

        <template v-slot:[`item.activo`]="{ item }">
          <v-chip small :color="item.activo ? 'green lighten-5' : 'grey lighten-3'"
            :text-color="item.activo ? 'green darken-3' : 'grey darken-3'">
            <v-icon left x-small>{{ item.activo ? "mdi-check-circle" : "mdi-minus-circle" }}</v-icon>
            {{ item.activo ? "Activo" : "Inactivo" }}
          </v-chip>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div class="pv-acciones">
            <v-tooltip top :disabled="item.activo">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-btn small depressed color="primary" :disabled="!item.activo" @click="openCaja(item)">
                    <v-icon left small>mdi-cash-register</v-icon>
                    Cajas
                  </v-btn>
                </span>
              </template>
              <span>El punto de venta está inactivo</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-btn icon :disabled="!puedeEditar(item)" aria-label="Editar punto de venta"
                    @click="openEditPunto(item)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </span>
              </template>
              <span>{{
                puedeEditar(item)
                  ? "Editar punto de venta"
                  : `Se puede editar desde el ${fechaEditable(item)}`
              }}</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon :loading="loadNew === item.id" aria-label="Generar código de devolución"
                  v-bind="attrs" v-on="on" @click="nuevoCodDevolucion(item.id)">
                  <v-icon>mdi-key-variant</v-icon>
                </v-btn>
              </template>
              <span>Generar código de devolución</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>

      <div v-if="itemsPuntos.length" class="pv-pie">
        <div class="pv-filas">
          <span>Filas por página</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn text small color="primary" v-on="on">
                {{ rowsPerPage }}
                <v-icon small>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item v-for="(number, index) in rowsPerPageArray" :key="index"
                @click="updateRowsPerPage(number)">
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <v-pagination v-if="pagination.total > 1" v-model="pagination.page" :length="pagination.total"
          :total-visible="pagination.visible" @input="onPageChange"></v-pagination>
      </div>
    </LayoutPage>
  </div>
</template>

<script>
import LayoutPage from "../../../LayoutPage.vue";
import moment from "moment";
import { Cuentas } from "../../../../services/cuentas";
import { Users } from "../../../../services/users";
import formatDate from "../../../../utils/formatDate";
import modalCaja from "./modal/modalCaja.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    name: "PuntoDeVenta",
    LayoutPage,
    modalCaja,
  },

  beforeRouteLeave(to, from, next) {
    this.setBusqueda(false);
    this.setUsuario([]);
    next();
  },
  data: function () {
    return {
      cliente_id: this.$route.params.cliente_id,
      cuentas_id: this.$route.params.cuenta_id,
      createCuenta: false,
      showForm: false,
      showFormCaja: false,
      showCaja: false,
      sucursal: {},
      usuarios: [],
      errored: false,
      menu: false,
      menu2: false,
      formatDate,
      currentCaja: {
        descripcion: "",
        fecha_alta: "",
        correo: "",
      },
      currentItem: {
        en_pronto_pagos: false,
        activo: false,
        calle: "",
        codigo_postal: "",
        codigo_sucursal_link: "",
        cuentas_id: "",
        fecha_alta: "",
        fecha_creacion: "",
        id: "",
        nombre: "",
        numero_calle: "",
        codigo_sucursal: "",
        provincia_id: "",
      },
      fechaMinima: moment().format("YYYY-MM-DD"),
      search: "",
      valid: false,
      edit: false,
      editCaja: false,
      loadNew: null,
      headers: [
        { text: "Punto de venta", value: "nombre" },
        { text: "Tipo", value: "en_pronto_pagos" },
        { text: "Código de sucursal", value: "codigo_sucursal_link" },
        { text: "Alta", value: "fecha_alta" },
        { text: "Estado", value: "activo" },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
      itemsPerPage: 10,
      pageCount: 0,
      // paginacion api
      pagination: {
        page: 1,
        total: 0,
        visible: 7,
      },
      rowsPerPageArray: [10, 20, 30],
      rowsPerPage: 10,
      cargando: false,
      cargandoCaja: false,
      itemsPuntos: [],
      itemsCaja: [],
      namecuenta: [
        (v) => !!v || "El nombre es obligatorio",
        (v) => (v && v.length <= 45) || "Máximo 45 caracteres",
        (v) =>
          /^[A-Za-z0-9_-]+$/.test(v) ||
          "Sin espacios ni símbolos, salvo - y _",
      ],
      fecha_alta: [(v) => !!v || "La fecha es requerida"],
      codigo_sucursal: [
        (v) => !!v || "El código de sucursal es requerido",
        (v) =>
          (v && v.length <= 50) ||
          "El código de sucursal no debe superar los 50 caracteres",
        (v) =>
          /^[A-Za-z0-9.-\s]+$/.test(v) ||
          "Solo numero y letras, sin ñ o acentos.",
      ],
      codigoPostal: [
        (v) => !!v || "El código postal es obligatorio",
        (v) => (v && v.length <= 25) || "Máximo 25 caracteres",
        (v) => /^[0-9\s]+$/.test(v) || "Solo números",
      ],
      calle: [
        (v) => !!v || "La calle es obligatoria",
        (v) => (v && v.length <= 145) || "Máximo 145 caracteres",
        (v) =>
          /^[A-Za-z0-9.-\s]+$/.test(v) ||
          "Solo letras y números, sin ñ ni acentos",
      ],
      nroCalle: [
        (v) => !!v || "El número es obligatorio",
        (v) => (v && v.length <= 15) || "Máximo 15 caracteres",
        (v) => /^[0-9\s]+$/.test(v) || "Solo números",
      ],
      correo: [
        (v) => !!v || "Correo es requerido",
        (v) =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "Correo debe ser válido",
      ],
    };
  },
  created() {
    this.getDatos();
  },

  computed: {
    ...mapGetters("cuentas", ["usuario_caja", "email", "loadingSearch", "busqueda", "usuario"]),
  },

  methods: {
    ...mapActions("cuentas", ["setUsuario", "setBusqueda"]),
    onPageChange() {
      this.getDatos();
    },
    direccion(item) {
      const calle = [item.calle, item.numero_calle].filter(Boolean).join(" ");
      const cp = item.codigo_postal ? `CP ${item.codigo_postal}` : "";
      return [calle, cp].filter(Boolean).join(" · ");
    },
    // Un punto de venta se puede editar recién 48 h después de su alta.
    puedeEditar(item) {
      return !moment().isBefore(
        moment(item.fecha_alta, "DD-MM-YYYY").add(2, "days")
      );
    },
    fechaEditable(item) {
      return moment(item.fecha_alta, "DD-MM-YYYY")
        .add(2, "days")
        .format("DD-MM-YYYY");
    },
    async copiar(texto) {
      try {
        await navigator.clipboard.writeText(texto);
        this.$toastr.s("Código copiado");
      } catch (e) {
        this.$toastr.e("No se pudo copiar el código");
      }
    },
    resetCurrentItem() {
      this.currentItem = {
        en_pronto_pagos: false,
        activo: false,
        calle: "",
        codigo_postal: "",
        codigo_sucursal_link: "",
        cuentas_id: "",
        fecha_alta: "",
        fecha_creacion: "",
        id: "",
        id_sucursal_link: "",
        nombre: "",
        numero_calle: "",
        codigo_sucursal: "",
        provincia_id: "",
      };
    },
    async openCaja(item) {
      this.sucursal = item;
      await this.getUsuarios();
      this.showCaja = true;
    },
    cerrar_caja() {
      this.showCaja = false;
      this.cajasID = 0;
    },
    openEditPunto(item) {
      this.showForm = true;
      this.edit = true;
      this.currentItem = { ...item };
      this.currentItem.fecha_alta = moment(
        this.currentItem.fecha_alta,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    },

    async nuevoCodDevolucion(params) {
      const result = await this.$swal({
        title: "¿Generar un nuevo código de devolución?",
        text: "El código anterior deja de servir.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#4CAF50",
        cancelButtonColor: "#f44336",
        confirmButtonText: "Generar",
        cancelButtonText: "Cancelar",
      });
      if (!result.value) return;

      this.loadNew = params;
      try {
        let response = await Cuentas.updateClavePuntodeVenta(params);

        this.$swal.fire({
          title: response.data.message,
          icon: "success",
          confirmButtonText: "Listo",
          confirmButtonColor: "#4CAF50",
        });
      } catch (error) {
        this.$swal.fire({
          title: "No se pudo generar el código",
          text: error.response?.data?.message || error.message,
          icon: "error",
          confirmButtonText: "Entendido",
          confirmButtonColor: "#4CAF50",
        });
      } finally {
        this.loadNew = null;
      }
    },

    cerrar_create() {
      this.showForm = false;
      this.edit = false;
      this.valid = false;
      this.resetCurrentItem();
      this.$refs.form_create.resetValidation();
    },
    cerrar_edit_punto() {
      this.showForm = false;
      this.edit = false;
      this.resetCurrentItem();
      this.valid = false;
      this.$refs.form_create.resetValidation();
    },
    openNewPunto() {
      this.showForm = true;
    },
    updateRowsPerPage(number) {
      this.rowsPerPage = number;
      this.pagination.page = 1;
      this.getDatos();
    },
    toast(name, msg, type, color) {
      this.$toastr.Add({
        name: name,
        title: "",
        msg: msg,
        clickClose: true,
        type: type,
        preventDuplicates: true,
        style: {
          color: "white",
          backgroundColor: color,
          width: "300px",
        },
      });
    },
    handleStore() {
      if (this.$refs.form_create.validate()) {
        this.store();
      } else {
        this.toast(
          "ErrorRequest",
          "Debe completar todos los datos",
          "info",
          "primary"
        );
      }
    },
    handleUpdate() {
      this.$refs.form_create.resetValidation();
      if (this.$refs.form_create.validate()) {
        this.update();
      } else {
        this.toast(
          "ErrorRequest",
          "Debe completar todos los datos",
          "info",
          "primary"
        );
      }
    },
    formatearFechaSiguiente(fecha) {
      return moment(fecha)
        .add(1, "days")
        .format("YYYY-MM-DDT00:00:00-00:00");
    },
    async deletePunto(item) {
      const { isConfirmed } = await this.$swal.fire({
        title: "¿Esta seguro?",
        text: "Esta acción eliminará el contacto",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Si, continuar",
        denyButtonText: "Cancelar",
      });

      if (isConfirmed) this.delete(item.id);
    },
    getDatos: function () {
      this.cargando = true;
      this.errored = false;
      Cuentas.getPuntosdeVenta(
        this.pagination.page,
        this.rowsPerPage,
        this.cuentas_id
      )
        .then((response) => {
          if (!response.data.data.puntos_ventas) {
            this.itemsPuntos = [];
            this.pagination.page = 1;
            this.pagination.total = 0;
          } else {
            this.itemsPuntos = response.data.data.puntos_ventas;
            this.pagination.page = response.data.data.meta.page.currentPage;
            this.pagination.total = response.data.data.meta.page.lastPage;
          }
        })
        .catch(() => {
          this.itemsPuntos = [];
          this.errored = true;
        })
        .finally(() => {
          this.cargando = false;
        });
    },
    getUsuarios: function async() {
      let params = {
        ClienteId: this.cliente_id,
        SistemaId: process.env.VUE_APP_SISTEMA_ID,
      };
      Users.getUsers(params)
        .then((response) => {
          this.usuarios = response?.data?.data;
        })
        .catch(() => {
          this.errored = true;
        })
        .finally(() => { });
    },
    store: function () {
      this.cargando = true;
      let body = {
        cuentas_id: this.cuentas_id,
        nombre: this.currentItem.nombre,
        fecha_alta: moment().format("YYYY-MM-DD") + "T00:00:00Z",
        calle: this.currentItem.calle,
        codigo_postal: this.currentItem.codigo_postal,
        numero_calle: this.currentItem.numero_calle,
        provincia_id: 6,
        localidad: "Corrientes",
        en_pronto_pagos: this.currentItem.en_pronto_pagos,
      };

      Cuentas.storePuntosdeVenta(body)
        .then((response) => {
          if (response.status == 200) {
            this.toast(
              "SuccessRequest",
              "El punto de venta se creó correctamente",
              "success",
              "green"
            );
          }
        })
        .catch((error) => {
          this.$toastr.e(
            error.response?.data?.message ||
            error.response?.data?.statusMessage ||
            "No se pudo crear el punto de venta"
          );
        })
        .finally(() => {
          this.getDatos();
          this.cerrar_create();
          this.cargando = false;
        });
    },
    update: async function () {
      const { isConfirmed } = await this.$swal.fire({
        title: "¿Guardar los cambios?",
        text:
          "El punto de venta se puede actualizar una vez cada 48 h hábiles.",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Sí, guardar",
        denyButtonText: "Cancelar",
      });

      if (isConfirmed) {
        this.cargando = true;
        this.currentItem.fecha_alta = this.formatearFechaSiguiente(
          moment().format("YYYY-MM-DD")
        );
        let body = {
          id: this.currentItem.id,
          cuentas_id: this.cuentas_id,
          nombre: this.currentItem.nombre,
          fecha_alta: this.currentItem.fecha_alta,
          activo: this.currentItem.activo,
          sucursal_codigo_to_update: this.currentItem.codigo_sucursal_link,
          sucursal_codigo: this.currentItem.codigo_sucursal,
          calle: this.currentItem.calle,
          numero_calle: this.currentItem.numero_calle,
          codigo_postal: this.currentItem.codigo_postal,
          provincia_id: this.currentItem.provincia_id,
          localidad: this.currentItem.localidad,
          en_pronto_pagos: this.currentItem.en_pronto_pagos,
        };

        Cuentas.updatePuntodeVenta(body)
          .then((response) => {
            if (response.status == 200) {
              this.$toastr.s("Se actualizaron los datos correctamente");
            }
          })
          .catch((error) => {
            this.$toastr.e(
              error.response?.data?.message ||
              error.response?.data?.statusMessage ||
              "No se pudo actualizar el punto de venta"
            );
          })
          .finally(() => {
            this.getDatos();
            this.cerrar_edit_punto();
            this.cargando = false;
          });
      }
    },
    delete: function (puntoventas_id) {
      this.cargando = true;
      Cuentas.deletePuntodeVenta(puntoventas_id)
        .then((response) => {
          if (response.status == 200) {
            this.$toastr.s("Punto de venta eliminado correctamente");
          }
        })
        .catch(() => {
          this.$toastr.e("Ocurrio un error al eliminar el punto de venta");
        })
        .finally(() => {
          this.cargando = false;
          this.getDatos();
        });
    },
  },
};
</script>
<style scoped>
.pv-barra {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.pv-dialogo-titulo {
  padding-bottom: 4px;
  text-align: left;
}

/* La app pinta en rojo todos los mensajes de los campos; acá las ayudas van en gris
   y solo los errores en rojo. */
.pv-dialogo>>>.v-messages:not(.error--text) {
  color: rgba(0, 0, 0, 0.6);
}

.pv-alerta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.pv-busqueda-titulo {
  font-weight: 500;
  margin-bottom: 6px;
}

.pv-busqueda {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 2px 16px;
  margin: 0;
}

.pv-busqueda dt {
  font-weight: 500;
}

.pv-busqueda dd {
  margin: 0;
}

.pv-tabla>>>th {
  white-space: nowrap;
}

.pv-tabla>>>td {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.pv-nombre {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.pv-secundario {
  font-size: 0.8125rem;
  color: rgba(0, 0, 0, 0.6);
}

.pv-codigo {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
}

.pv-codigo-texto {
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}

.pv-acciones {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  flex-wrap: nowrap;
}

.pv-vacio {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 40px 16px;
}

.pv-vacio-titulo {
  margin: 8px 0 0;
  font-size: 1rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.pv-vacio-texto {
  margin: 0 0 12px;
  color: rgba(0, 0, 0, 0.6);
}

.pv-pie {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 12px;
}

.pv-filas {
  display: flex;
  align-items: center;
  gap: 4px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875rem;
}
</style>
